import LegalDocument from '../../components/legal/LegalDocument';
import { termsOfServiceContent } from '../../content/legal/terms-of-service';

export default function TermsOfServicePage() {
  return (
    <LegalDocument title="Terms of Service">
      {termsOfServiceContent}
    </LegalDocument>
  );
}
